import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../theme"; 

// import Echeck from "./views/Echeck";
import { useGridApiRef } from "@mui/x-data-grid";
import Active from "./Views/Active";
import Inactive from "./Views/Inactive";
import Blocked from "./Views/Blocked";
import TabView3 from "../../../components/theme/TabView3/TabView3";
import { warehouseRelationConfig } from "./warehouseRelationConfig";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTopbar } from "../../../contexts/TopbarProvider";
import { useGetRelationTotalsQuery } from "../../../newapi/global/relation/relationSlice";
import { useSelector } from "react-redux";
import { defaultPollingInterval } from "../../../utils/constants";

const WarehouseRelation = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const {showExtraTitle,clearExtraTitle } = useTopbar();
    const { data : relationTotals, isLoading: totalIsLoading } = useGetRelationTotalsQuery(undefined, { pollingInterval: defaultPollingInterval });
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const [config, setConfig] = useState(warehouseRelationConfig(isFulfilment));

    useEffect(() => {
        setConfig(warehouseRelationConfig(isFulfilment, relationTotals));
    }, [isFulfilment,relationTotals]);
    

    useEffect(() => {
        showExtraTitle(t("relations"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box 
        sx={{
            background:"", 
            width:1,
            paddingTop:9,
            position:"relative",
            "@media screen and (max-width:47.9375em)" : {
                    background:"", 
                width:1,
                marginTop:9,
                height: "calc(100% - 72px)",
                // position:"relative",
                paddingX:4,
                paddingTop:4,
                overflow:"hidden",
                display:"flex",
                flexDirection:"column",
                
            },
            "@media screen and (max-width: 47.9375em)" : {
                paddingX:0,
                paddingTop:3,
                background:colors.bg["tertiary"],
                "&:before,&:after":{
                    display:"none"
                }
            },
        }}
        >      
            <TabView3
                tabConfig={config}
                // viewType="bodytabs"
                sx={{

                    background:"green",
                    minHeight:"calc(100%)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,
                    display:"flex",
                    flexDirection:"column",
                    // "@media screen and (max-width: 47.9375em)" : {
                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:"40px",
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },
        
                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:"40px",
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },
                        "@media screen and (max-width: 47.9375em)" : {

                            "&:before, &:after" : {
                                top:0,
                            }
                        }
                }}
            >
                <>
                    <Active config={warehouseRelationConfig.active}/>
                    <Inactive config={warehouseRelationConfig.inactive}/>
                    <Blocked config={warehouseRelationConfig.blocked}/>
                </>
            </TabView3>

        </Box>
    )
};

export default WarehouseRelation;
